import { render, staticRenderFns } from "./AdministratorList.vue?vue&type=template&id=3241996a&scoped=true&"
import script from "./AdministratorList.vue?vue&type=script&lang=js&"
export * from "./AdministratorList.vue?vue&type=script&lang=js&"
import style0 from "./AdministratorList.vue?vue&type=style&index=0&id=3241996a&lang=scss&scoped=true&"
import style1 from "./AdministratorList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3241996a",
  null
  
)

export default component.exports